class UserFormController {
    constructor($state, usersService, messageService, permissionsService) {
        this.$state = $state;
        this.usersService = usersService;
        this.messageService = messageService;
        this.user = permissionsService.user;
    }

    $onInit () {
        if (!this.targetuser.local) {
            this.targetuser.local = { properties: [], permissions: [] };
        }

        this.editingSelf = JSON.parse(localStorage.getItem('profile')).sub === this.targetuser.local.id;
    }

    onSave () {
        if (!this.targetuser) {
            this.targetuser = this.user;
        }

        if (this.targetuser.profile) this.targetuser.local.id = this.targetuser.profile.id;

        return this.usersService.save(this.targetuser.local)
            .then(() => {
                this.messageService.success(`The user <strong>${this.targetuser.profile.email}</strong> was successfully updated!`, [`app.admin.user-edit({ 'targetuser' : '${this.targetuser.profile.id}'})`, `User`]);

                this.$state.go('app.admin.users');
            })
            .catch(() => {
                // var sourceElement = Object.keys(error['data'])[0];
                // this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
            })
            ;
    }
}

UserFormController.$inject = ['$state', 'usersService', 'messageService', 'permissionsService'];

export default UserFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/controllers/user.form.controller.js